import React from "react";
import { Divider} from "antd";
import { calculateBuyAmount, save} from "./AdjustmentService";
import { useEffect, useState } from "react";
import { formatToCurrencyWithScale } from "../../../helpers/FormatHelper";
import LoadingBox from "../../shared/LoadingBox";
import AlertBox from "../../shared/AlertBox";

export function AdjustmentSummary({objAdjustment, buyScale, backScreen, cancelAdjustment, baseCurrencySymbol, baseCurrencyName, newAdjustment, updateAdjustmentRowCostRate, reload, getAdjustmentUpdated}){

        const userID=localStorage.getItem('UserID');
        const [adjustmentID, setAdjustmentID] = useState('');
        const [loading, setLoading] = useState(false);
        const [alertTitle, setAlertTitle] = useState('');
        const [alertMessage, setAlertMessage] = useState('');
        const [comments, setComments] = useState('');
        const [showAlert, setShowAlert] = useState(false);
        const [saved, setSaved] = useState(false);
        const [totalAdjusted, setTotalAdjusted] = useState(0);


    useEffect(() => {
      if (objAdjustment && objAdjustment.AdjustmentID && objAdjustment.AdjustmentID !== '') {
        setAdjustmentID(objAdjustment.AdjustmentID)
      }
    }, [objAdjustment, objAdjustment.AdjustmentID])    

    useEffect(() => {
      if (objAdjustment && objAdjustment.Comments !== undefined && objAdjustment.Comments !== null) {
        setComments(objAdjustment.Comments)
      }
    }, [objAdjustment, objAdjustment.Comments])

    useEffect(() => {
      if (objAdjustment && objAdjustment.CanEdit === 0) {
        setSaved(true)
      }
    }, [objAdjustment, objAdjustment.CanEdit])  

    useEffect(() => {
      if (objAdjustment) {
        setTotalAdjusted(objAdjustment.TotalAdjusted);
      }
    }, [objAdjustment, objAdjustment.TotalAdjusted, reload])  


     const onChangeCostRateValue =(value, index)=>{        
        const adjustmentRow = objAdjustment.AdjustmentRows[index];
        
        const adjustmentRowAux = JSON.parse(JSON.stringify(adjustmentRow))
        const amountByCostRate = calculateBuyAmount(adjustmentRowAux.RateTerms, Number(value), adjustmentRowAux.Amount, buyScale);

        adjustmentRowAux.CostRate = Number(value);
        adjustmentRowAux.BuyAmount = amountByCostRate;

        objAdjustment.AdjustmentRows[index] = adjustmentRowAux;

        updateAdjustmentRowCostRate(objAdjustment);
        
    }



    const getRows=()=>{
        const rows = [];
        if(objAdjustment.AdjustmentRows)
        {
            objAdjustment.AdjustmentRows.forEach((o, index) =>{

                rows.push(<div id={`adjustmentsummary4-${index}`} key ={`adjustmentsummary4-${index}`} className="uk-grid margin-left-detail-summary" style={{marginTop:'5px',paddingLeft:'20px',paddingRight:'20px'}}>

                <div id={`adjustmentsummary41-${index}`} key ={`adjustmentsummary41-${index}`} className="uk-width-1-4 summary-row">{o.CurrencyName}</div>
                <div id={`adjustmentsummary45-${index}`} key ={`adjustmentsummary45-${index}`} className="uk-width-1-8 summary-row">{o.AdjustmentType}</div>
                <div id={`adjustmentsummary42-${index}`} key ={`adjustmentsummary42-${index}`} className="uk-width-1-8 summary-row uk-amount">{formatToCurrencyWithScale(o.Amount,o.CurrencyScale)}</div>
                <div id={`adjustmentsummary435-${index}`} key ={`adjustmentsummary435-${index}`} className={`uk-width-1-8 summary-row uk-amount`}>
                   {/*<NumberInput id={`adjustmentsummary54-cost-rate-${index}`} className="uk-adjustment-row-rate-input" value={o.CostRate} type={'Rate'}
                           onChange ={(event) => {onChangeCostRateValue(event.target.value, index)}} scale={o.RatePrecision} disabled={saved} />
                    */}
                    {formatToCurrencyWithScale(o.CostRate,o.RatePrecision)}
                </div>

               
                <div id={`adjustmentsummary44-${index}`} key ={`adjustmentsummary44-${index}`} className={`uk-width-1-8 summary-row uk-amount`}>{formatToCurrencyWithScale(o.BuyAmount,buyScale)}</div>
                <div id={`adjustmentsummary45-${index}`} key ={`adjustmentsummary45-${index}`} className={`uk-width-1-4 summary-row`}>{o.Comments}</div>

            </div>)
            })
        }
        return rows;
    }

    const saveAdjustment = async(confirm) =>{
        setLoading(true);
        objAdjustment.Status = confirm?'Confirmed':'Pending';
        const responseSave = await save(objAdjustment,comments, userID);
        setLoading(false);    
        const message = [];
        message.push(responseSave.Message);    
        if(responseSave.Success)
        {
            if(adjustmentID === '')
            {
                getAdjustmentUpdated(responseSave.AdjustmentID);
            }
            
            setSaved(true);
        }

        setAlertTitle(responseSave.Title);
        setAlertMessage(message);
        setShowAlert(true);
    }

      const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

       const onCommentsChange = (e) =>{
        if(e.target.value)
        {
            setComments(e.target.value);
        }
    }

    const backClick = () =>{
        objAdjustment.Comments = comments;
        backScreen(objAdjustment)
    }

    return <div id={'adjustmentsummary1'} key ={'adjustmentsummary1'}>
        { <div id={'adjustmentsummary11'} key ={'adjustmentsummary11'} className="uk-grid margin-left-detail-summary">
        </div>}
            <div id={'adjustmentsummary2'} key ={'adjustmentsummary2'} className='uk-grid margin-left-detail-summary'>
               
                    <div id={'adjustmentsummary211'} key ={'adjustmentsummary211'} className="uk-width-1-1 summary-subtitle">{`Adjustment Info`}</div>

                    <div id={'adjustmentsummary2111'} key ={'adjustmentsummary2111'} className="uk-width-1-6">{`Vault: `}</div>
                    <div id={'adjustmentsummary2112'} key ={'adjustmentsummary2112'} className="uk-width-5-6" >{objAdjustment.VaultName}</div>
                    <div id={'adjustmentsummary2113'} key ={'adjustmentsummary2113'} className="uk-width-1-6">{`Currency: `}</div>
                    <div id={'adjustmentsummary2114'} key ={'adjustmentsummary2114'} className="uk-width-5-6" >{baseCurrencyName}</div>
                    <div id={'adjustmentsummary2115'} key ={'adjustmentsummary2115'} className="uk-width-1-6">{`Reference Type: `}</div>
                    <div id={'adjustmentsummary2116'} key ={'adjustmentsummary2116'} className="uk-width-5-6" >{objAdjustment.ReferenceType}</div>
                    <div id={'adjustmentsummary2117'} key ={'adjustmentsummary2117'} className="uk-width-1-6">{`Reference ID: `}</div>
                    <div id={'adjustmentsummary2118'} key ={'adjustmentsummary2118'} className="uk-width-5-6" >{objAdjustment.ReferenceID}</div>
                    <div id={'adjustmentsummary2119'} key ={'adjustmentsummary2119'} className="uk-width-1-6">{`Reference Date: `}</div>
                    <div id={'adjustmentsummary2120'} key ={'adjustmentsummary2120'} className="uk-width-5-6" >{`${new Date(objAdjustment.ReferenceDate).toDateString()}`}</div>
                    <div id={'adjustmentsummary2119'} key ={'adjustmentsummary2119'} className="uk-width-1-6">{`Accounting Date: `}</div>
                    <div id={'adjustmentsummary2120'} key ={'adjustmentsummary2120'} className="uk-width-5-6" >{`${new Date(objAdjustment.AccountingDate).toDateString()}`}</div>


            </div>
            
            <div  id={'adjustmentsummary3'} key ={'adjustmentsummary3'} className="uk-grid margin-left-detail-summary">

                <div id={'adjustmentsummary31'} key ={'adjustmentsummary31'} className="uk-width-1-1 summary-subtitle">{'Details'}</div>
                
                <div id={'adjustmentsummary311'} key ={'adjustmentsummary311'} className="uk-width-1-4 bold-text adjustment-row-title">{'Currency'}</div>
                <div id={'adjustmentsummary317'} key ={'adjustmentsummary317'} className="uk-width-1-8 bold-text adjustment-row-title">{'Type'}</div>
                <div id={'adjustmentsummary312'} key ={'adjustmentsummary312'} className="uk-width-1-8 bold-text adjustment-row-title">{'Amount'}</div>
                <div id={'adjustmentsummary313'} key ={'adjustmentsummary313'} className={`uk-width-1-8 bold-text adjustment-row-title`}>{'Cost Rate'}</div>
                
                <div id={'adjustmentsummary314'} key ={'adjustmentsummary314'} className={`uk-width-1-8 bold-text adjustment-row-title`}>{`${objAdjustment.CurrencyID} Value`}</div>
                <div id={'adjustmentsummary311'} key ={'adjustmentsummary311'} className="uk-width-1-4 bold-text adjustment-row-title">{'Comments'}</div>

           
            </div>
            {getRows()}         
            <div id={'adjustmentsummary6'} key={'adjustmentsummary6'} className="uk-grid margin-left-detail-summary">
                <div id={'adjustmentsummary65'} key ={'adjustmentsummary65'} className="uk-width-1-1 summary-subtitle">{`Total `}</div>
            </div>
            <div id={'adjustmentsummary7'} key={'adjustmentsummary7'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'adjustmentsummary71'} key={'adjustmentsummary71'} className="uk-width-1-8">{`Total ${objAdjustment.CurrencyID}`}</div>
                <div id={'adjustmentsummary72'} key={'adjustmentsummary72'} style={{textAlign:'right'}}>{baseCurrencySymbol}</div>
                <div id={'adjustmentsummary73'} key={'adjustmentsummary73'} className="uk-width-1-8 uk-amount" style={{paddingLeft:'0px'}}>{formatToCurrencyWithScale(totalAdjusted,buyScale)}</div>
            </div>

            <div id={'adjustmentsummary20'} key={'adjustmentsummary20'} className="uk-grid margin-left-detail-summary">
                <div id={'adjustmentsummary201'} key ={'adjustmentsummary201'} className="uk-width-1-1 summary-subtitle">{'Comments'}</div>
            </div>

            {!saved  && 
            <div id={'adjustmentsummary202'} key ={'adjustmentsummary202'} className="uk-grid margin-left-detail-summary">
                <textarea id={'adjustmentsummaryComments'} key={'adjustmentsummaryComments'} className='uk-textarea' value={comments} onChange={onCommentsChange} /> 
            </div>
            }
            {saved && 
            <div id={'adjustmentsummary203'} key ={'adjustmentsummary203'} className="uk-grid margin-left-detail-summary">
                <div id={'adjustmentsummary204'} key ={'adjustmentsummary204'} className="uk-width-1-1">{`${comments}`}</div>
            </div>
            }


            <Divider/>
            <div className="margin-left-detail-summary" style={{ marginTop: '20px', marginBottom: '20px', padding: 0, textAlign:'end' }}>
                {saved &&
                <button className="uk-button uk-button-green" onClick={newAdjustment}>
                    {'New Adjustment'}
                </button>}

                {!saved &&
                <button className="uk-button uk-button-green" onClick={backClick}>
                    {'Back'}
                </button>
                }
                {!saved &&
                <button className="uk-button uk-button-green" onClick={()=>saveAdjustment(false)}>
                    {'Save as Pending'}
                </button>
                }
                {!saved &&
                <button className="uk-button uk-button-green" onClick={()=>saveAdjustment(true)}>
                    {'Confirm'}
                </button>
                }
                <button className="uk-button uk-button-green" onClick={cancelAdjustment}>
                    {'Exit'}
                </button>
            </div>
            <LoadingBox loading={loading}/>
            <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
        </div>
}

export default AdjustmentSummary